namespace Ir.Components.Workbook.ToolBar.ShowErrorsToolBar {
    interface IViewModel {
        dataGridOptions: DevExpress.ui.dxDataGrid.Properties;
        tabPanelOptions: DevExpress.ui.dxTabPanel.Properties;
        mapping: string;
        workbook: KnockoutComputed<string>;
        isWorkbook: KnockoutComputed<boolean>;
    }

    let popupComponent: DevExpress.ui.dxPopup;
    let dataGridComponent: DevExpress.ui.dxDataGrid;
    let tabPanelComponent: DevExpress.ui.dxTabPanel;
    let errorSelected: KnockoutObservable<ErrorBase> = ko.observable();
    let errorType: KnockoutObservable<ErrorTypeEnum> = ko.observable(ErrorTypeEnum.Mapping);

    export function getViewModel(this: IViewModel, params: any) {
        this.isWorkbook = ko.computed(function () { return errorType() === ErrorTypeEnum.Workbook; });
        this.mapping = (workbook?.workbookConfig?.mappingId ?? 0)?.toString();
        let mappingName = workbook?.workbookConfig?.mappingName ?? "";
        if (mappingName) {
            this.mapping = `${this.mapping} - ${mappingName}`;
        }

        this.workbook = ko.computed(function () {
            let workbookId = workbook?.workbookConfig?.workbookId() ?? 0;
            let workbookName = workbook?.workbookConfig?.workbookName ?? "";
            if (workbookName) {
                return `${workbookId} - ${workbookName}`;
            }

            return workbookId?.toString();
        });
        
        this.dataGridOptions = {
            height: "calc(50% - 25px)",
            width: "100%",
            paging: {
                enabled: false
            },
            scrolling: {
                useNative: false
            },
            keyExpr: "id",
            dataSource: ko.computed(function () {
                return ErrorService.errors().filter(x => x.type === errorType());
            }) as any,
            columns: [
                {
                    dataField: "datetime",
                    caption: "Date",
                    width: 120
                },
                {
                    dataField: "userMessage",
                    caption: "Message"
                },
                {
                    dataField: "workbookTab",
                    caption: "Tab",
                    width: 150
                },
                {
                    dataField: "widget",
                    width: 150
                },
                {
                    type: "buttons",
                    width: 50,
                    buttons: [{
                        hint: "Copy to clipboard",
                        icon: "copy",
                        onClick: function (e) {
                            let message = errorSelected().toString();
                            irGlobal.copyTextToClipboard(message, "Details copied to clipboard");
                        }
                    }]
                }
            ],
            showBorders: true,
            focusedRowEnabled: true,
            focusedRowIndex: 0,
            noDataText: "",
            onInitialized(e) {
                dataGridComponent = e.component;
            },
            onFocusedRowChanging(e) {
                errorSelected(e.rows.length > 0 ? e.rows[0].data : null);
                tabPanelComponent?.repaint();
            }
        }
        this.tabPanelOptions = {
            dataSource: [
                {
                    title: 'Message',
                    template: () => {
                        return $("<div></div>").dxTextArea({
                            value: ko.computed(function () {
                                let userMessage = errorSelected()?.userMessage;
                                let errorMessage = errorSelected()?.errorMessage;
                                if (!userMessage || userMessage === errorMessage) {
                                    return errorMessage;
                                }

                                return `${userMessage}\n\n----------------------------------------\n\n${errorMessage}`;
                            }) as any,
                            height: "100%",
                            readOnly: true,
                            stylingMode: "underlined"
                        });
                    },
                },
                {
                    title: 'Parameters',
                    template: () => {
                        return $("<div></div>").dxTextArea({
                            value: ko.computed(function () {
                                return errorSelected()?.parameters;
                            }) as any,
                            height: "100%",
                            readOnly: true,
                            stylingMode: "underlined"
                        });
                    },
                },
                {
                    title: 'Call Stack',
                    template: () => {
                        return $("<div></div>").dxTextArea({
                            value: ko.computed(function () {
                                return errorSelected()?.stackTrace;
                            }) as any,
                            height: "100%",
                            readOnly: true,
                            stylingMode: "underlined"
                        });
                    },
                }
            ],
            selectedIndex: 0,
            width: '100%',
            height: "calc(50% - 25px)",
            animationEnabled: false,
            swipeEnabled: true,
            tabsPosition: "top",
            stylingMode: "secondary",
            onInitialized(e) {
                tabPanelComponent = e.component;
            }
        };
    }

    export function show(type: ErrorTypeEnum) {
        errorSelected(ErrorService.errors()[0]);
        errorType(type);

        if (popupComponent) {
            popupComponent.show();
        }
        else {
            let popupOptions = {
                width: 1000,
                height: '90%',
                showTitle: true,
                title: "Issues occurred",
                visible: false,
                dragEnabled: false,
                hideOnOutsideClick: false,
                showCloseButton: true,
                position: {
                    at: "center",
                    my: "center",
                },
                toolbarItems: [
                    {
                        widget: 'dxButton',
                        toolbar: 'top',
                        location: 'after',
                        options: {
                            icon: "clearformat",
                            hint: 'Clear Issues',
                            elementAttr: {
                                style: "border: none"
                            },
                            onClick() {
                                errorSelected(null);
                                tabPanelComponent?.repaint();
                                ErrorService.clearOfType(errorType());
                            },
                        },
                    }
                ],
                onInitialized(e) {
                    popupComponent = e.component;
                    popupComponent.show();
                },
                onShowing(e) {
                    if (dataGridComponent) {
                        dataGridComponent.option("focusedRowIndex", 0);
                    }
                    if (tabPanelComponent) {
                        tabPanelComponent.option("selectedIndex", 0);
                    }
                }
            } as DevExpress.ui.dxPopover.Properties;

            let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <show-errors-toolbar></show-errors-toolbar>
            </div>`);
            $popover.appendTo('body');

            ko.applyBindings({ popupOptions }, $popover[0]);
        }
    }
}